import { Role, User } from "../../../models/UserModel";
import { useAuth } from "react-oidc-context";
import { useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { updateUser } from "../../../services/UserAPI";
import { useEffect } from "react";

type EditUserForm = {
  roles: Array<string>;
};

export default function EditUser(props: {
  roles: Array<Role>;
  user?: User;
  onUpdateUser: (user: User) => void;
  show: boolean;
  onHide: () => void;
}) {
  const auth = useAuth();
  const {
    register,
    handleSubmit,
    reset,
    setValue
  } = useForm<EditUserForm>({
    defaultValues: {
      roles: [],
    },
  });

  useEffect(() => {
    setValue("roles", props.user?.roles ?? [])
  }, [props.user]);

  const onUpdateUser = (data: EditUserForm) => {
    if (!props.user) {
        props.onHide();
        return;
    }
    const newUserObj: User = {...props.user, ...{roles: data.roles}};
    updateUser(auth?.user?.access_token, newUserObj).then((res) => {
      props.onHide();
      reset();
      props.onUpdateUser(res.data);
    })
  };

  return (
    <Modal show={props.show} onHide={props.onHide} centered>
      <form onSubmit={handleSubmit(onUpdateUser)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit - {props.user?.userName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-body">
            <div className="col-12">
              <label className="form-label">Roles</label>
              <div className="input-group" id="show_hide_password">
                {props.roles.map((role) => (
                  <div className="form-check" key={`edit${role.id}`}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`checkboxEdit${role.name}`}
                      value={role.name}
                      {...register("roles")}
                    />
                    <label
                      className="form-check-label custom-checkbox-label"
                      htmlFor={`checkboxEdit${role.name}`}
                    >
                      {role.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="reset"
            className="btn btn-secondary"
            onClick={props.onHide}
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
